import { Leaf } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FOOTER } from '@/constants/testIds';
import { useI18n } from '@/i18n/I18nProvider';
import KlymartLogo from './KlymartLogo';

export default function Footer() {
  const { m } = useI18n();
  return (
    <footer
      data-testid={FOOTER.root}
      className="border-t border-border mt-10"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-2.5 text-sm text-muted-foreground">
          <KlymartLogo size={28} />
          <span>
            <span className="text-foreground font-medium">Klymart®</span>
            &nbsp;· {m.footer.tagline}
          </span>
        </div>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm">
          <Link
            to="/privacy"
            data-testid={FOOTER.privacy}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            {m.footer.privacy}
          </Link>
          <Link
            to="/impressum"
            data-testid={FOOTER.impressum}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            {m.footer.impressum}
          </Link>
          <Link
            to="/terms"
            data-testid={FOOTER.terms}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            {m.footer.terms}
          </Link>
          <Link
            to="/contact"
            data-testid={FOOTER.contact}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            {m.footer.contact}
          </Link>
          <span className="text-muted-foreground">© {new Date().getFullYear()}</span>
          <Leaf className="sr-only" />
        </div>
      </div>
    </footer>
  );
}
